(() => {
  let revision = 0;

  const updateShipping = (requiresShipping) => {
    document.querySelectorAll('[data-cart-shipping]').forEach((element) => {
      element.hidden = !requiresShipping;
    });
    document.querySelectorAll('[data-cart-digital]').forEach((element) => {
      element.hidden = requiresShipping;
    });
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    const currentRevision = ++revision;
    let cart = event.cartData;

    if (typeof cart?.requires_shipping !== 'boolean') {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) return;
        cart = await response.json();
      } catch {
        return;
      }
    }

    if (currentRevision === revision && typeof cart.requires_shipping === 'boolean') {
      updateShipping(cart.requires_shipping);
    }
  });
})();
